// extracted by mini-css-extract-plugin
export default {"root":"Features_root__s-z0k","inView":"Features_inView__cgLZN","movein":"Features_movein__2Eju9"};